export default class AcompanhamentoEntregaFOB {
  id: number;
  tipo: string;
  pedido: number;
  item: string;
  sku: number;
  descricaoSku: string;
  quantidade: number;
  dataRemessa: Date;
  dataEntrega: Date;
  remessa: string;
  tms: string;
  clifor: string;
  placaCarreta: string;
  loadJDA: string;
  placaCavalo: string;
  d_E_L_E_T_E: boolean;
  criadoEm: Date;
  excluidoEm: Date;
  contrato?: string;
  contratoSap?: string;

  constructor(
    id: number,
    tipo: string,
    pedido: number,
    item: string,
    sku: number,
    descricaoSku: string,
    quantidade: number,
    dataRemessa: Date,
    dataEntrega: Date,
    remessa: string,
    tms: string,
    clifor: string,
    placaCarreta: string,
    loadJDA: string,
    placaCavalo: string,
    d_E_L_E_T_E: boolean,
    criadoEm?: Date,
    excluidoEm?: Date,
    contrato?: string,
    contratoSap?: string
  ) {
    this.id = id;
    this.tipo = tipo;
    this.pedido = pedido;
    this.item = item;
    this.sku = sku;
    this.descricaoSku = descricaoSku;
    this.quantidade = quantidade;
    this.dataRemessa = dataRemessa;
    this.dataEntrega = dataEntrega;
    this.remessa = remessa;
    this.tms = tms;
    this.clifor = clifor;
    this.placaCarreta = placaCarreta;
    this.loadJDA = loadJDA;
    this.placaCavalo = placaCavalo;
    this.d_E_L_E_T_E = d_E_L_E_T_E;
    this.criadoEm = criadoEm ?? new Date();
    this.excluidoEm = excluidoEm ?? new Date();
    this.contrato = contrato;
    this.contratoSap = contratoSap;
  }

  static toJson(acompanhamentoEntregaFOB: AcompanhamentoEntregaFOB): string {
    return JSON.stringify(acompanhamentoEntregaFOB);
  }

  static fromJson(json: object[]): AcompanhamentoEntregaFOB[] {
    let acompanhamentoEntregaFOBArr: AcompanhamentoEntregaFOB[] = [];
    json.forEach((item: any) => {
      acompanhamentoEntregaFOBArr.push(
        new AcompanhamentoEntregaFOB(
          item["id"],
          item["tipo"],
          item["pedido"],
          item["item"],
          item["sku"],
          item["descricaoSku"],
          item["quantidade"],
          new Date(item["dataRemessa"]),
          new Date(item["dataEntrega"]),
          item["remessa"],
          item["tms"],
          item["clifor"],
          item["placaCarreta"],
          item["loadJDA"],
          item["placaCavalo"],
          item["d_E_L_E_T_E"],
          new Date(item["criadoEm"]),
          new Date(item["excluidoEm"]),
          item["contrato"],
          item["contratoSap"],
        )
      );
    });
    return acompanhamentoEntregaFOBArr;
  }
}
